import { LIST_GC_TIME_MS, LIST_STALE_TIME_MS, useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { PaginatedResponse, SpaceWithSiteCount } from '@klareospace/pharos-lib-types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { createSpaceApi, spaceKeys } from '../api';
import type { SearchSpacesParams } from '../api';

export interface UseSpacesOptions extends SearchSpacesParams {
  enabled?: boolean;
}

export function useSpaces(params: UseSpacesOptions): UseQueryResult<PaginatedResponse<SpaceWithSiteCount>> {
  const { enabled = true, ...searchParams } = params;
  const client = useApiClient('admin-auth');
  const api = createSpaceApi(client);

  return useQuery({
    enabled,
    gcTime: LIST_GC_TIME_MS,
    queryFn: () => api.searchSpaces(searchParams),
    queryKey: spaceKeys.search(searchParams),
    staleTime: LIST_STALE_TIME_MS,
  });
}
